import React, {Component} from 'react';
import PropTypes from 'prop-types';
import events from "./Events/EventSource";
import _ from 'lodash';

/**
 * Manages subscription to events with react component lifecycle
 */
class EventListener extends Component{

    static propTypes = {
        children: PropTypes.any,
        events: PropTypes.any,
        onEvent: PropTypes.func,
        disableRender: PropTypes.bool
    };

    static defaultProps = {
        disableRender: true
    };

    _handleEvent(key,data){

        if(this.props.onEvent){

            if(_.isArray(this.props.events))
                this.props.onEvent(key,data);
            else if(_.isString(this.props.events))
                this.props.onEvent(data);

        }

        if(!this.props.disableRender) {
            this.forceUpdate();
        }

    }

    componentDidMount() {

        if(_.isArray(this.props.events)){
            this.props.events.forEach(e => events.on(e,this._handleEvent.bind(this,e)))
        }
        else if(_.isString(this.props.events)){
            events.on(this.props.events,this._handleEvent.bind(this,this.props.events));
        }

    }

    componentWillUnmount() {

        if(_.isArray(this.props.events)){
            this.props.events.forEach(e => events.removeAllListeners(e));
        }
        else if(_.isString(this.props.events)){
            events.removeAllListeners(this.props.events);
        }

    }

    render(){
        return <React.Fragment>
            {this.props.children}
        </React.Fragment>

    }

}

export default EventListener;


// WEBPACK FOOTER //
// ./src/common/EventListener.js